<template>
  <canvas width="240" height="90" ref="captchaComp"></canvas>
</template>

<script>
import CaptchaMini from "captcha-mini";
export default {
  data() {
    return {
      timer: "",
    };
  },
  mounted() {
   
    let captcha1 = new CaptchaMini({
      fontSize: 30,
    });
    captcha1.draw(this.$refs.captchaComp, (r) => {
    
       this.changeVal(r)
    });
  },
  methods:{
      changeVal(val){
         this.$emit("setCaptchaNum",val)
      }
  },
};
</script>

<style>
</style>